import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OpdRefreshService {
  /** Emits the patient_id whenever any OPD chart section is saved */
  private _prescriptionSaved$ = new Subject<string>();
  prescriptionSaved$ = this._prescriptionSaved$.asObservable();

  notifyPrescriptionSaved(patient_id: string) {
    this._prescriptionSaved$.next(patient_id);
  }
}
